/*eslint-disable*/
import React from 'react'

import ClearIcon from 'assets/icons/clear-icon'

import PotentialCoProposerMenuList from './Menu/PotentialCoProposerMenuList'
import { AddCoProposerChip, AddCoProposerInput, AddCoProposerWrapper, AdditionalInfo } from './style'

const AddCoProposerMenu = ({
  makeFocus,
  inputRef,
  searchQuery,
  handleChangeQuery,
  chips,
  handleSelect,
  potentialCoProposers,
  setChips,
  setQuery,
  onEnterPress,
  reviewersMenu = false
}) => {
  function handleRemove(id) {
    setChips(
      (s) => {
        return s.filter((proposerId) => {
          return proposerId.id !== id
        })
      }
    )
  }


  return (
    <AddCoProposerWrapper onClick={makeFocus}>
      {chips.map((chip) => {
        return (
          <AddCoProposerChip key={chip.id} userFound={chip.firstName}>
            <span style={{paddingRight: '12px'}}>{chip.email}</span>
            <span style={{cursor: 'pointer'}}
              onClick={() => {
                handleRemove(chip.id)
              }}
            >
              <ClearIcon />
            </span>
          </AddCoProposerChip>
        )
      })}
      <div style={{position: 'relative', display: 'inline-block'}} >
        <AddCoProposerInput data-test='insert-email-input' placeholder={chips.length === 0 ? 'Enter emails(comma separated)': ''} ref={inputRef} value={searchQuery} onChange={handleChangeQuery} onKeyDown={onEnterPress} />
        <PotentialCoProposerMenuList
          query={searchQuery}
          chips={chips}
          onSelect={handleSelect}
          list={potentialCoProposers}
          setQuery={setQuery}
        />
      </div>
      <AdditionalInfo >
        <span>{chips.length} Users</span>
        <span>{reviewersMenu ? 'RFP' : 'Individual, NCG'}</span>
      </AdditionalInfo>
    </AddCoProposerWrapper>
  )
}

export default AddCoProposerMenu
